export default __webpack_public_path__ + "static/media/phonebooth_screen_background_lightOff.e13f8e8b.webp";